import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useAuth from '../hooks/useAuth';
import MainLoader from "../components/MainLoader";

export default function ImpersonateRedirect() {
  const location = useLocation();
  const { setAuth } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    const expires_at = params.get("expires_at");
  
    if (token) {
      localStorage.setItem("token", token);
      localStorage.setItem("impersonation", "true");
      localStorage.setItem("impersonation_expire", expires_at);
      setAuth(null);
      // Delay navigation slightly so logs/storage flush
      // setTimeout(() => {
        window.location.href = "/" // replace avoids back-button loop
      // }, 3000);
    } else {
      window.location.href = "/"
    }
  }, []);

  return <MainLoader/>
}
